// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._4itEB{display:block}._4itEB ._7OfPX{padding-top:8px}@media screen and (min-width:768px){._4itEB ._7OfPX{padding:16px 0 0}}._4itEB ._7OfPX[data-first]{padding-top:0}.\\+ahqF{margin:28px 0 20px}@media screen and (min-width:768px){.\\+ahqF{margin:48px 0 32px}}.E63y4{position:relative;min-height:300px;margin:0 0 8px}._8oxJV{position:absolute;top:0;left:0;width:calc(100vw - 16px);height:100%;padding:32px 40px;border:1px solid #e2e2e2;margin:0 8px;background:#fff;border-radius:8px;font-size:16px;line-height:24px;text-align:center}._8oxJV>span{color:#f02d37}@media screen and (min-width:768px){._8oxJV{width:100%;height:auto;min-height:96px;padding:32px;margin:0;font-size:18px;line-height:32px}}.uLX9E{position:absolute;z-index:1;top:0;left:0;display:flex;width:100%;height:72px;flex-direction:column;justify-content:center}.yviFV{margin:16px 0}@media screen and (min-width:768px){.yviFV{margin-bottom:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "_4itEB",
	"grid": "_7OfPX",
	"insertion": "+ahqF",
	"content": "E63y4",
	"notFound": "_8oxJV",
	"loader": "uLX9E",
	"footerLoader": "yviFV"
};
module.exports = ___CSS_LOADER_EXPORT___;
